import config from 'config';

export const afterpayMessaging = (tld, customizedConfig) => {
  const apConfig = {
    ...config.get('public.afterpay')[tld],
    ...customizedConfig,
  };

  if (tld === '.com') {
    // eslint-disable-next-line new-cap
    return new window.presentAfterpay(apConfig);
  }
  if (tld === '.co.uk') {
    // eslint-disable-next-line new-cap
    return new window.presentClearpay(apConfig);
  }
};
